/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'
import { get } from 'lodash'
/**
 * Import
 * - Store
 */
import { RootState } from '../../../../../store'

/**
 * Import
 * - Actions
 */
import {
    setStep03,
    resetQuotes,
    setStep03Renewals,
    getRenewalVariation,
    getQuoteVariation,
    getFullQuote,
} from '../../../../../actions'

/**
 * Import
 * - Page component
 */
import Step03 from '../components/Step03c'

const getAgreedItems = (agreeList: any) => {
    let agreedItems = [
        {
            type: 'picturesPainingsPrints',
            text: 'Pictures / Paintings / Prints',
            items: [],
            apiName: 'pictures_painings_prints',
        },
        {
            type: 'antiquesFurniture',
            text: 'Antiques / Furniture',
            items: [],
            apiName: 'antiques_furniture',
        },
        {
            type: 'bronzesSculpturesMarbles',
            text: 'Bronzes / Sculptures / Marbles',
            items: [],
            apiName: 'bronzes_sculptures_marbles',
        },
        {
            type: 'preciousMetalsCoinsMedals',
            text: 'Precious Metals / Coins / Medals',
            items: [],
            apiName: 'precious_metals_coins_medals',
        },
        {
            type: 'porcelainBrittleItems',
            text: 'Porcelain / Brittle Items',
            items: [],
            apiName: 'porcelain_brittle_items',
        },
        {
            type: 'carpetsRugsTapestriesTextiles',
            text: 'Carpets / Rugs / Tapestries / Textiles',
            items: [],
            apiName: 'carpets_rugs_tapestries_textiles',
        },
        {
            type: 'clocks',
            text: 'Clocks / Barometers',
            items: [],
            apiName: 'clocks',
        },
        {
            type: 'fineWinesAndSpirits',
            text: 'Fine wines and spirits',
            items: [],
            apiName: 'fine_wines_and_spirits',
        },
        {
            type: 'collectiblesMemorabilia',
            text: 'Collectibles / Memorabilia',
            items: [],
            apiName: 'collectibles_memorabilia',
        },
        {
            type: 'booksMapsEphemera',
            text: 'Books / Maps / Ephemera',
            items: [],
            apiName: 'books_maps_ephemera',
        },
    ]
    if (Object.values(agreeList).length) {
        for (const [left, right] of Object.entries(agreeList)) {
            let aindex = agreedItems.findIndex(a => a.apiName === left)
            if (aindex !== -1) {
                let arr: any[] = []
                Object.values(right).map((ai) => {
                    let sarr: any = {
                        title: ai.title,
                        insured: ai.insured,
                        agreed_value: ai.agreed_value,
                    }
                    arr.push(sarr)
                })
                let items = 'items'
                agreedItems[aindex][items] = arr
            }
        }
    }

    return agreedItems
}

const getUnspecifiedItems = (unspecifiedList) => {
    let unspecifiedItems = [
        {
            type: 'picturesPainingsPrints',
            text: 'Pictures / Paintings / Prints',
            marketValue: '0',
            sumInsured: 0,
            apiName: 'pictures_painings_prints',
        },
        {
            type: 'antiquesFurniture',
            text: 'Antiques / Furniture',
            marketValue: '0',
            sumInsured: 0,
            apiName: 'antiques_furniture',
        },
        {
            type: 'bronzesSculpturesMarbles',
            text: 'Bronzes / Sculptures / Marbles',
            marketValue: '0',
            sumInsured: 0,
            apiName: 'bronzes_sculptures_marbles',
        },
        {
            type: 'preciousMetalsCoinsMedals',
            text: 'Precious Metals / Coins / Medals',
            marketValue: '0',
            sumInsured: 0,
            apiName: 'precious_metals_coins_medals',
        },
        {
            type: 'porcelainBrittleItems',
            text: 'Porcelain / Brittle Items',
            marketValue: '0',
            sumInsured: 0,
            apiName: 'porcelain_brittle_items',
        },
        {
            type: 'carpetsRugsTapestriesTextiles',
            text: 'Carpets / Rugs / Tapestries / Textiles',
            marketValue: '0',
            sumInsured: 0,
            apiName: 'carpets_rugs_tapestries_textiles',
        },
        {
            type: 'clocks',
            text: 'Clocks / Barometers',
            marketValue: '0',
            sumInsured: 0,
            apiName: 'clocks',
        },
        {
            type: 'fineWinesAndSpirits',
            text: 'Fine wines and spirits',
            marketValue: '0',
            sumInsured: 0,
            apiName: 'fine_wines_and_spirits',
        },
        {
            type: 'collectiblesMemorabilia',
            text: 'Collectibles / Memorabilia',
            marketValue: '0',
            sumInsured: 0,
            apiName: 'collectibles_memorabilia',
        },
        {
            type: 'booksMapsEphemera',
            text: 'Books / Maps / Ephemera',
            marketValue: '0',
            sumInsured: 0,
            apiName: 'books_maps_ephemera',
        },
    ]
    if (Object.values(unspecifiedList).length) {
        for (const [left, right] of Object.entries(unspecifiedList)) {
            let uindex = unspecifiedItems.findIndex(u => u.apiName === left)
            if (uindex !== -1) {
                let sumInsured = 'sumInsured'
                let marketValue = 'marketValue'
                unspecifiedItems[uindex][sumInsured] = right
                unspecifiedItems[uindex][marketValue] = right
            }
        }
    }
    return unspecifiedItems
}

const mapStateToProps = (state: RootState, props: any) => {
    return {
        quote: state.quote,
        fullQuote: get(state.quote, 'full.response.quote', {}),
        agreedItems: getAgreedItems(get(state.quote, 'full.response.quote.stockBusinessAssets.agreedItems', {})),
        unspecifiedItems: getUnspecifiedItems(
            get(state.quote, 'full.response.quote.stockBusinessAssets.unspecifiedItems', {})),
        editRenewals: true,
    }
}

export default connect(
    mapStateToProps,
    {
        setStep03: setStep03,
        setStep03Renewals: setStep03Renewals,
        resetQuotes: resetQuotes,
        getRenewalVariation,
        getQuoteVariation,
        getFullQuote,
    }
)(Step03)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Renewals/EditRenewals/containers/Step03c.tsx